import { parseBoolean, useGlobalContext, useShortlist } from '@honeycomb/data';
/**
 * React hook that checks whether a given hotel is shortlisted for the current user.
 *
 * It uses global config settings to determine if the shortlist feature is enabled,
 * queries the shortlist data, and returns:
 * - `isShortlisted`: whether the provided `estabId` exists in the shortlist
 * - `shortlistEnabled`: whether the shortlist feature is enabled in configuration
 *
 * @param estabId - The hotel establishment ID to check against the shortlist
 * @returns {UseIsHotelShortlistedResult} An object containing shortlist state
 */
export function useIsHotelShortlisted(estabId) {
    var _a, _b, _c;
    const { configSettings: { EnableShortlist: ShortlistEnabled }, } = useGlobalContext();
    const shortlistEnabled = parseBoolean(ShortlistEnabled);
    const { data } = useShortlist([], !shortlistEnabled);
    const estabsInShortlist = (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.getShortlist) === null || _a === void 0 ? void 0 : _a.hotels) === null || _b === void 0 ? void 0 : _b.map((hotel) => hotel.estabId.toString())) !== null && _c !== void 0 ? _c : [];
    const isShortlisted = estabsInShortlist.includes(estabId);
    return { isShortlisted, shortlistEnabled };
}
